import ImageZoom from "../../commons/ImageZoom";

export default function ThreeJs() {

  return (
    <div className="container" style={{height: '100vh' }}>
        <h1 className="text-center mt-5">
            Plan 3D avec Three.js
        </h1>
        <div className="row" style={{marginTop: '80px'}}>
            <div className="col-12 col-lg-6 col-xxl-4 mt-5" style={{}}>
            <iframe
                pointerEvents="none"
                style={{
                width: '360px',
                height: '640px',
                transformOrigin: 'top left',
                border: '10px black solid',
                boxShadow: '12px 24px 24px rgba(0, 0, 0, 0.5)',
                borderRadius: '20px',
                margin: 'auto',
                cursor: 'pointer',
                }}
                src="https://app.mytreeosk.com/project/b3e386ed-a787-4dfe-b102-72119a0ef2e4/preview/page/182259e1-8720-4f7e-b860-e5ac6931a4bc"
            ></iframe>
            </div>
            <div className="col col-12 col-lg-6 mt-5 col-xxl-4">
                <img style={{width: '360px', height: 'auto', borderRadius: '1em', boxShadow: 'rgba(0,0,0,0.4) 12px 12px 24px'}} alt={'Exemple'} src={'./assets/exemple kiosk.jpeg'}/>
            </div>
            <div className="col-12 col-lg-6 mt-3 col-xxl-4 mb-5 mt-5">
                <p>
                    Découvrez un salon d’exposition interactif en 3D conçu avec Three.js et React. Ce projet permet aux visiteurs de naviguer librement dans un espace immersif, mettant en avant des stands, des produits et des présentations en temps réel.
                </p>
                <ul>
                    <li>
                    Navigation fluide 🕹️ : Déplacez-vous librement avec une caméra intuitive.
                    </li>
                    <li>
                    Stands interactifs 🎪 : Cliquez sur un stand pour afficher des infos détaillées.
                    </li>
                    <li>
                    Éclairage et ambiance réalistes 💡 : Lumières dynamiques et ombres soignées.
                    </li>
                    <li>
                    Optimisation WebGL 🚀 : Expérience fluide, même sur navigateur.
                    </li>
                </ul>
                <br/>
                <a href="mailto:julien.j.1999@hotmail.com">Contactez-moi: julien.j.1999@hotmail.com</a>
            </div>
        </div>
    </div>
  );
}
